import { render, staticRenderFns } from "./bon-consultation.html?vue&type=template&id=94f53ca2&scoped=true&external"
import script from "./bon-consultation.js?vue&type=script&lang=js&external"
export * from "./bon-consultation.js?vue&type=script&lang=js&external"
import style0 from "./bon-consultation.scss?vue&type=style&index=0&id=94f53ca2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f53ca2",
  null
  
)

export default component.exports